"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function (r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function () { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function (r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function (r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { AG_API_KEY, GRAPH_SERVICE_API } from '@autoguru/global-configs';
import { meros } from 'meros';
import { Observable } from 'relay-runtime';
import { relayLogFn } from './environment';
import { createGraphError } from './utils';
export const fetchQuery = function fetchQuery() {
  let {
    getToken,
    scheme = 'Bearer'
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (params, variables, _cacheConfig, _uploadables) => Observable.create(sink => {
    const id = params.id || params.cacheID;
    const postBody = params.id !== null ? {
      id: params.id,
      variables
    } : {
      id: params.cacheID,
      query: params.text,
      variables
    };
    const headers = {
      Accept: 'application/json, multipart/mixed',
      'Content-Type': 'application/json',
      'x-api-key': AG_API_KEY
    };
    Promise.resolve().then(async () => {
      let maybeToken = '';
      // biome-ignore lint/suspicious/noAssignInExpressions: migration quick fix. To be fixed when code is touched
      if (maybeToken = await (getToken === null || getToken === void 0 ? void 0 : getToken())) headers['Authorization'] = `${scheme} ${maybeToken}`;
      const response = await globalThis.fetch(`${GRAPH_SERVICE_API}/graphql`, {
        method: 'POST',
        cache: 'no-cache',
        headers,
        body: JSON.stringify(postBody)
      }).then(r => meros(r)).catch();
      if (isAsyncIterable(response)) {
        var _iteratorAbruptCompletion = false;
        var _didIteratorError = false;
        var _iteratorError;
        try {
          for (var _iterator = _asyncIterator(response), _step; _iteratorAbruptCompletion = !(_step = await _iterator.next()).done; _iteratorAbruptCompletion = false) {
            const part = _step.value;
            {
              if (!part.json) throw new Error('Expected JSON from part, but received something else.');
              const {
                data,
                path,
                hasNext,
                label,
                errors,
                extensions
              } = part.body;
              if (Array.isArray(errors)) {
                throw createGraphError(errors);
              }
              sink.next({
                data,
                path,
                label,
                errors,
                extensions: _objectSpread(_objectSpread({}, extensions), {}, {
                  is_final: !hasNext
                })
              });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (_iteratorAbruptCompletion && _iterator.return != null) {
              await _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        const responseData = typeof (response === null || response === void 0 ? void 0 : response.json) === 'function' ? await response.json() : null;
        if (!responseData || Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.errors)) {
          const error = createGraphError(responseData.errors);
          if (!responseData.data) throw error;
          relayLogFn({
            name: 'network.error',
            error,
            networkRequestId: id
          });
          if (responseData !== null && responseData !== void 0 && responseData.errors) sink.error(responseData.errors);
        }
        sink.next(responseData);
      }
      sink.complete();
    }).catch(error => {
      sink.error(error);
    });
  });
};
const isAsyncIterable = val => typeof val < 'u' && val !== null && (val[Symbol.toStringTag] === 'AsyncGenerator' ||
// @ts-ignore
Symbol.asyncIterator && Symbol.asyncIterator in val);